var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LightVariationGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A3_Light_variation_group_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 67h4v9h-4v-9zm12.85-3.51l6.36 6.36L46 67l-6.36-6.36-2.79 2.85zM6.15 66.8L9 69.62l6.36-6.36-2.83-2.83-6.38 6.37zM9 48H0v4h9v-4zm26.25 4H53V29.58L23.44 52h11.81zm11.19-26.21H76V3.37L46.44 25.79zM34.26 55a9.38 9.38 0 11-12.37-12.89l1.11-.55V36h6v5.84s4-3.07 4-3.09v-5.73a6.82 6.82 0 00-7-6.78A6.92 6.92 0 0019 33v5.75A13.39 13.39 0 1038.51 55h-4.25zm8.54-23.66a9.36 9.36 0 012.09-15.44l1.11-.55V9.79h6v5.56s4.13-2.73 4-2.81c-.13-.08 0-5.67 0-5.73A6.82 6.82 0 0049 0a6.92 6.92 0 00-7 6.79v5.75a13.352 13.352 0 00-2.15 21.08l2.95-2.28z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A3_Light_variation_group_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/A3_Light_variation_group.d61fc9fc.svg";
export { SvgA3LightVariationGroup as ReactComponent };